"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var _MediaContext = require("../../MediaContext/MediaContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MediaModal = function MediaModal(_ref) {
  var noPadding = _ref.noPadding,
    title = _ref.title,
    text = _ref.text,
    toggle = _ref.toggle,
    cta = _ref.cta,
    noCloseIcon = _ref.noCloseIcon,
    image = _ref.image,
    video = _ref.video;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: !noPadding ? {
      padding: 'calc(var(--component-padding) * 2)'
    } : {
      padding: 0
    }
  }, !noCloseIcon && !cta && /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.XS
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal--close-desktop"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "cross",
    buttonType: _constants.BUTTON_TYPES.BARE,
    onClick: toggle,
    buttonSize: _constants.BUTTON_SIZES.LARGE
  }))), video && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('media-wrapper', 'd8-u-radius-md', 'd8-u-overflow-hidden', 'margin-y-md', loading && 'modal--placeholder')
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    style: {
      width: '100%'
    },
    title: "title",
    src: video,
    onLoad: function onLoad() {
      return setLoading(false);
    },
    frameBorder: "0",
    allow: "autoplay; encrypted-media",
    allowFullScreen: "true",
    webkitallowfullscreen: "true",
    mozallowfullscreen: "true"
  })), !video && image && /*#__PURE__*/_react["default"].createElement("div", {
    className: "aspect-16-9 d8-u-bg-img d8-u-radius-md margin-y-md",
    style: {
      backgroundImage: "url(".concat(image.url, ")")
    },
    "aria-label": image.alt
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, title && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-ls-sm d8-u-color-primary text-md margin-bottom-md"
  }, title), text && /*#__PURE__*/_react["default"].createElement("p", null, text)), cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md flex justify-end flex-column"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Close",
    buttonType: _constants.BUTTON_TYPES.BARE,
    onClick: toggle
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-top-sm",
    text: cta.text,
    link: cta.link,
    buttonType: cta.buttonType
  })), !cta && !noCloseIcon && /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.XS
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md text-center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Close",
    buttonType: _constants.BUTTON_TYPES.BARE,
    onClick: toggle
  }))));
};
MediaModal.propTypes = {
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  toggle: _propTypes["default"].func,
  cta: _propTypes["default"].object,
  image: _propTypes["default"].object,
  noPadding: _propTypes["default"].bool,
  noCloseIcon: _propTypes["default"].bool,
  video: _propTypes["default"].string
};
var _default = exports["default"] = MediaModal;